/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="371.73"
        height="215"
        viewBox="0 0 371.73 215"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          d="M180.12 24.11c37.41 16.27 68.68 21.4 93.83 15.39.11.3 2.94 53.53-10.29 101.13-14.41 36.63-43 62.23-80.63 74.33-.36.5-53.73-5.31-84.79-68.3-8.31-27.17-13.83-58.06-13.83-107.17 35.53 6.01 67.44.87 95.73-15.39Z"
          style={{ fill: '#246096' }}/>
        <path
          d="M138.77 88.61c5.19 0 9.4-4.55 9.4-10.17s-4.21-10.17-9.4-10.17-9.4 4.55-9.4 10.17 4.21 10.17 9.4 10.17ZM149.94 91.84h-21.4c-4.6 0-10.46 2.42-10.46 10.38v24.8c0 1.12.58 3.29 3.43 3.29l6.19.06v-8.32 41.59c0 1.47.62 3.72 3.69 3.96h5.46c1.87.04 2.81-.71 2.81-2.24.48 1.58 1.44 2.32 2.88 2.24 0 .03 6.57 0 6.57 0 2.88 0 2.62-2.9 2.62-3.96v-40.2 6.93s6.12.02 6.12 0c1.72 0 3.01-1.57 3.01-3.35v-24.8c0-11.29-10-10.38-10.91-10.38Z"
          style={{ fill: '#93d4f5' }}/>
        <path
          d="M126.78 130.62v-23.28M152.64 130.62v-23.28"
          style={{
            fill: 'none',
            isolation: 'isolate',
            opacity: '.76',
            stroke: '#0b4a7b',
            strokeLinecap: 'round',
            strokeWidth: '1.65px',
          }}/>
        <path
          d="M139.74 131.34v35.24"
          style={{
            fill: 'none',
            stroke: '#056899',
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeWidth: '1.65px',
          }}/>
        <path
          d="M220.66 92.59c4.76 0 8.62-4.29 8.62-9.58s-3.86-9.58-8.62-9.58-8.62 4.29-8.62 9.58 3.86 9.58 8.62 9.58ZM227.64 95.92h-12.27c-4.21 0-8.24 1.91-9.21 6.98l-5.96 22.63c0 1.05-1.31 3.85 2.15 4.83l4.73.98s.76-2.62 2.26-7.85c-2.85 9.69-4.49 15.22-4.93 16.59-.21.64.02.95.54.95h6.39v22.18c0 1.37.57 3.48 3.39 3.71h4.17c1.72.04 2.58-.66 2.58-2.1.44 1.48 1.32 2.18 2.64 2.1 0 .02 5.19 0 5.19 0 2.64 0 2.4-2.72 2.4-3.71v-22.03c0-.11 5.04-.14 7.1-.14.67 0 1.03-.74.87-1.32-.42-1.58-2.1-6.31-5.04-14.18 1.07 3.87 1.6 5.8 1.6 5.8s4.4-.9 4.4-.92c2.53-.8 2.49-3.13 2.09-4.88-4.32-15.09-6.49-22.63-6.49-22.63-1.59-5.89-7.76-6.98-8.6-6.98Z"
          style={{ fill: '#93d4f5' }}/>
        <path
          d="m206.14 131.43 5.33-20.55M237.48 131.01l-6.55-20.13"
          style={{
            fill: 'none',
            isolation: 'isolate',
            opacity: '.76',
            stroke: '#0b4a7b',
            strokeLinecap: 'round',
            strokeWidth: '1.65px',
          }}/>
        <path
          d="M221.55 142.65v23.34"
          style={{
            fill: 'none',
            stroke: '#056899',
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeWidth: '1.65px',
          }}/>
        <path
          d="M180.17 112.81c3.78 0 6.84-3.41 6.84-7.61s-3.06-7.61-6.84-7.61-6.84 3.41-6.84 7.61 3.06 7.61 6.84 7.61ZM190.19 116.27h-18.52c-3.35 0-6.56 3.69-6.56 7.75v15.78c0 .75.42 2.2 2.5 2.2l4.5.04v-5.57 27.81c0 .98.45 2.49 2.69 2.65h3.97c1.36.03 2.05-.47 2.05-1.49.35 1.05 1.05 1.55 2.1 1.49 0 .02 4.78 0 4.78 0 2.1 0 1.91-1.94 1.91-2.65V137.4v4.64s4.45.01 4.45 0c1.25 0 2.19-1.05 2.19-2.24v-15.78c0-5.79-5.39-7.75-6.05-7.75Z"
          style={{ fill: '#93d4f5' }}/>
        <path
          d="M171.29 141.9v-16.57M190.41 141.9v-16.57"
          style={{
            fill: 'none',
            isolation: 'isolate',
            opacity: '.76',
            stroke: '#0b4a7b',
            strokeLinecap: 'round',
            strokeWidth: '1.65px',
          }}/>
        <path
          d="M180.88 141.9v24.35"
          style={{
            fill: 'none',
            stroke: '#056899',
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeWidth: '1.65px',
          }}/>
        <path
          d="M184.77 71.37c-1.55.02-3.04.58-4.16 1.58l-.75.67-.75-.67c-1.14-1.02-2.68-1.58-4.26-1.58s-3.22.59-4.38 1.66c-2.27 2.12-2.17 5.53.18 7.64l9 8.07c.11.1.29.1.41 0l9-8.07c2.35-2.11 2.46-5.52.19-7.64-1.16-1.08-2.74-1.66-4.38-1.66h-.11Z"
          style={{ fill: '#fdb71d' }}/>
        <path
          d="M0 163.13h371.73v43.56H0z"
          style={{ fill: 'none' }}/>
        <path
          d="M358.25 29.42c2.49 0 2.48-2.98 2.48-2.98.37-5.06-3.7-9.25-8.69-9.77C351.76 7.42 344.11 0 334.71 0a17.35 17.35 0 0 0-15.83 10.16 12.43 12.43 0 0 0-5.55-1.31c-6.23 0-11.38 4.55-12.28 10.47-.45-.07-.9-.08-1.37-.12-4.2-.33-8.66 3.63-7.81 8.47 0 0 .35 1.75 2.32 1.75h64.06ZM63.21 88.94c2.29 0 2.29-2.75 2.29-2.75.34-4.66-3.41-8.52-8.01-9-.26-8.52-7.3-15.36-15.97-15.36-6.5 0-12.08 3.85-14.59 9.36-1.54-.76-3.27-1.2-5.11-1.2-5.74 0-10.48 4.19-11.31 9.65-.41-.07-.83-.07-1.26-.11-3.87-.31-7.98 3.34-7.2 7.8 0 0 .33 1.61 2.13 1.61h59.03Z"
          style={{
            fill: '#fff',
            isolation: 'isolate',
            opacity: '.15',
          }}/>
      </svg>

    );
  }
}

Icon.displayName = 'FamilyShieldCloudsIcon';

export default Icon;
